module.exports = __webpack_public_path__ + "img/4.7181e5be.png";